import { render, staticRenderFns } from "./ModernAntimatterDimensionRow.vue?vue&type=template&id=3271241e&scoped=true&"
import script from "./ModernAntimatterDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ModernAntimatterDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ModernAntimatterDimensionRow.vue?vue&type=style&index=0&id=3271241e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271241e",
  null
  
)

export default component.exports